// 网页全屏逻辑
export default {
  data() {
    return {
      windowHeight: window.screen.height,
    };
  },
  computed: {
    fullRate() {
      let rate = 1;
      // 红包高度(380px) / 屏幕高度, 确保横屏下比例保持在0.8
      if (this.windowHeight * 0.8 < 380) {
        rate = 0.8 / (380 / this.windowHeight);
      }
      return rate;
    }
  },
  mounted() {
    this.initOnorientationchange();
    // 修复在横屏下刷新，获取到是竖屏高度。
    this.onOrientationChangeHandle();
  },
  beforeDestroy() {
    this.destroyOnorientationchange();
  },
  methods: {
    destroyOnorientationchange() {
      window.removeEventListener(
        'onorientationchange' in window ? 'orientationchange' : 'resize',
        this.onOrientationChangeHandle,
        false
      );
    },
    initOnorientationchange() {
      window.addEventListener(
        'onorientationchange' in window ? 'orientationchange' : 'resize',
        this.onOrientationChangeHandle,
        false
      );
    },
    onOrientationChangeHandle() {
      // 参考观看页监听屏幕旋转逻辑，等界面重新渲染后获取body高度
      setTimeout(() => {
        this.windowHeight = document.body.clientHeight;
      }, 200);
    },
  }
};
